import * as React from 'react';
import useStore from 'Hooks/useStore';
import { UserRoles } from 'Models/Enums';

export default (roles: UserRoles[]) => {
	const store = useStore();

	if (!roles.length) {
		return false;
	}

	const currentUserGroups = store.userGroups.map(ug => ug.name);

	// early return if user is a super admin
	if (currentUserGroups?.includes('Super Administrators')) {
		return true;
	}

	return roles.some(r => currentUserGroups.includes(r));
};
